import React, { useState, Fragment, useEffect } from 'react';
import { Formik } from 'formik';
import {
  CommonInput,
  CommonCheckbox,
  PopUp,
  useWindowResize,
  ThankYouPage,
  NewSpinner,
} from '@fincity-frontend/shared-ui';
import {
  consentUserCampaign,
  getCampaignOtp,
} from '../../common/constants/api';
import logo from '../../images/consumer/logoV1.png';
import * as Yup from 'yup';
import { navigate } from 'gatsby';
import { validate as validatePhoneNumber } from '../../common/constants/PhoneNumberValidation';
import { Append_0 } from '../../common/constants/Append_0';
import CommonOtpInput from '../../common/components/CommonOtpInput/CommonOtpInput';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import CircularLoading from '../../common/components/CircularLoading/CircularLoading';
import Layout from '../../components/Layout/Layout';
import disbursed from '../../images/campaign/disbursed1.svg';
import credit from '../../images/campaign/credit.svg';
import trust from '../../images/campaign/trust1.svg';
import expAdv from '../../images/campaign/expAdv.svg';
import lp from '../../images/campaign/lp1.svg';
import bp from '../../images/campaign/bp1.svg';
import iso from '../../images/campaign/iso.svg';
import safe from '../../images/campaign/safe.svg';
import logo1x from '../../images/campaign/logo.png';
import logo2x from '../../images/campaign/logo2x.png';
import back1x from '../../images/campaign/bg.jpg';
import back2x from '../../images/campaign/bg.jpg';
import lnLogoBlue from '../../images/campaign/LnLogoBlue.svg';
import lnLogoBlack from '../../images/campaign/mainLogoBlack.png';
import lnLogoBlack2x from '../../images/campaign/mainLogoBlack2x.png';
import leftHome from '../../images/campaign/leftHome.png';
import check from '../../images/campaign/check.svg';
import checkWhite from '../../images/campaign/checkWhite.svg';
import checkBlack from '../../images/campaign/checkBlack.svg';
// medical
import medExp from '../../images/campaign/bg/medical.jpg';
import medExp2x from '../../images/campaign/bg/medical.jpg';
// homeReno
import homeReno from '../../images/campaign/bg/Renovation.jpg';
import homeReno2x from '../../images/campaign/bg/Renovation.jpg';
// wedding
import wedding from '../../images/campaign/bg/wedding.jpg';
import wedding2x from '../../images/campaign/bg/wedding.jpg';
// education
import edu from '../../images/campaign/bg/education.jpg';
import edu2x from '../../images/campaign/bg/education.jpg';
// creditCard
import cred from '../../images/campaign/bg/debitcard.jpg';
import cred2x from '../../images/campaign/bg/debitcard.jpg';
// bt
import bt from '../../images/campaign/bg/balancetransfer.jpg';
import bt2x from '../../images/campaign/bg/balancetransfer.jpg';
//pl
import pl from '../../images/campaign/bg/interestrate.jpg';
import pl2x from '../../images/campaign/bg/interestrate.jpg';
//minDoc
import minDoc from '../../images/campaign/bg/document.jpg';
import minDoc2x from '../../images/campaign/bg/document.jpg';
//minSal
import sl from '../../images/campaign/bg/salary.jpg';
import sl2x from '../../images/campaign/bg/salary.jpg';

import './style.css';

const footerItems = [
  {
    logo: {
      src: trust,
      alt: 'trust',
    },
    title: 'Trusted by',
    subTitle: '50,000+ Customers',
  },
  {
    logo: {
      src: bp,
      alt: 'bp',
    },
    title: '50+ ',
    subTitle: 'Banking Partners',
  },
  {
    logo: {
      src: disbursed,
      alt: 'disbursed',
    },
    title: 'Disbursed',
    subTitle: 'Rs.2,000 Cr',
  },
  {
    logo: {
      src: lp,
      alt: 'lp',
    },
    title: '1,000+',
    subTitle: 'Loan Products',
  },
  {
    logo: {
      src: expAdv,
      alt: 'expAdv',
    },
    title: 'Free',
    subTitle: 'Expert Advice',
  },
  {
    logo: {
      src: credit,
      alt: 'credit',
    },
    title: 'Free',
    subTitle: 'Credit Report',
  },
];
const AdvBlock = ({
  absolute,
  windowWidth,
  textColor,
  checkImg,
  isDefault,
}) => (
  <div
    className={
      (textColor === 'black' && !absolute ? 'text-black-250' : 'text-white') +
      (isDefault
        ? ' xl:mt-44 xxl:mt-56 md:mt-4  pt-1 md:mr-auto xmd:ml-12 xmd:mr-0 xl:mx-auto xl:-ml-5 '
        : '') +
      (absolute
        ? ' absolute z-50 mt-4 left-1/10 top-0 py-10 block md:hidden'
        : ' xxl:space-y-3') +
      (windowWidth < 768 && absolute ? '  space-y-2' : '')
    }
    style={{
      fontSize: absolute ? '5vw' : windowWidth > 1440 ? '6vw' : '',
      marginLeft: !absolute && windowWidth < 812 ? '-10px ' : '',
    }}
  >
    <div className="flex items-center space-x-1">
      <img className="block mr-2 w-6 h-6" src={checkImg} alt="check" />
      <span className="font-roboto md:text-xl xmd:text-2xl  ml-3 block font-semibold">
        10.49%
      </span>
      <span className="text-xs xxl:text-xl mt-1 uppercase">Starting rate</span>
    </div>
    <div className="flex items-center space-x-1">
      <img className="block mr-2 w-6 h-6 " src={checkImg} alt="check" />
      <span className="font-roboto md:text-xl xmd:text-2xl font-semibold ml-3 block">
        24 Hours
      </span>
      <span className="text-xs xxl:text-xl mt-1 uppercase">Disbursement</span>
    </div>
    <div className="flex items-center space-x-1">
      <img className="block mr-2 w-6 h-6 " src={checkImg} alt="check" />
      <span className="font-roboto md:text-xl xmd:text-2xl font-semibold ml-3 block">
        50 Lakhs
      </span>
      <span className="text-xs xxl:text-xl mt-1 uppercase">Loan amount</span>
    </div>
    <div className="flex items-center space-x-1">
      <img className="block mr-2 w-6 h-6 " src={checkImg} alt="check" />
      <span className="font-roboto md:text-xl xmd:text-2xl  font-semibold ml-3 block">
        Rs. 25,000
      </span>
      <span className="text-xs xxl:text-xl mt-1 uppercase">Minimum salary</span>
    </div>
    <div className="flex items-center space-x-1">
      <img className="block mr-2 w-6 h-6 " src={checkImg} alt="check" />
      <span className="font-roboto md:text-xl xmd:text-2xl  font-semibold ml-3 block">
        Guaranteed
      </span>
      <span className="text-xs xxl:text-xl mt-1 uppercase">cashback</span>
    </div>
  </div>
);

const campaign = ({
  consentFlow,
  userDetails,
  managerDetailsConsent,
  submitApi,
  requestId,
}) => {
  const [show, setShow] = useState(false);
  const [type, setType] = useState('loading');
  const [text, setText] = useState('loading...');
  const [dontClose, setDontClose] = useState(true);
  const [showMore, setShowMore] = useState(false);
  const [windowWidth, windowHeight] = useWindowResize();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [params, setParams] = useState('');
  const [loanType, setLoanType] = useState('Personal Loan');
  const [source, setSource] = useState('SMS');
  const [code, setCode] = useState('');
  const [otp, setOtp] = useState('');
  const [callingApi, setCallingApi] = useState(false);
  const [timeLeft, setTimeLeft] = useState(0);
  const [errMsg, setErrMsg] = useState('');
  const [showOptComp, setShowOptComp] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const [checkToRedirect, setCheckToRedirect] = useState(false);
  let backGrndImg,
    backGrndImg2x,
    checkImg,
    textColor,
    leftHeading,
    formHeading,
    isDefault = code === '4833255c-93cd-4a06-8a4f-91add21a5dcd',
    mainLogo = logo1x,
    mainLogo2x = logo2x;

  useEffect(() => {
    setParams(new URL(window.location.href).searchParams);
  }, []);
  useEffect(() => {
    if (params) {
      setLoanType(params.get('loanType'));
      setSource(params.get('source'));
      setCode(params.get('code'));
      setCheckToRedirect(true);
    }
  }, [params]);
  useEffect(() => {
    if (
      !consentFlow &&
      checkToRedirect &&
      code !== '4833255c-93cd-4a06-8a4f-91add21a5dcd' &&
      code !== '49cf6f3c-6030-4869-b155-10ea3102b892' &&
      code !== 'ebce3582-b118-4545-98dd-1b8c1a19b6b2' &&
      code !== '8a8991fb-c413-4cb0-9fd7-dd9a6e731ecc' &&
      code !== 'c04ff766-36de-4fb7-86d6-0257358de674' &&
      code !== '17c7f699-966c-4f30-bf81-9a7c655280bc' &&
      code !== '66744846-56c0-4131-9df3-6b079b301a56' &&
      code !== '37bbaf4a-905d-45f1-b7fe-cddb7617f758' &&
      code !== 'e186bd48-e4e2-4667-b70a-49e9b18f9244' &&
      code !== 'c7a51442-4868-4f62-ba7c-0148554d9c61'
    )
      navigate('https://fincity.com/');
  }, [checkToRedirect]);

  switch (code) {
    // defaultOne
    case '4833255c-93cd-4a06-8a4f-91add21a5dcd':
      backGrndImg = back1x;
      backGrndImg2x = back2x;
      checkImg = check;
      textColor = 'white';
      leftHeading = '50+ Banks under one roof';
      formHeading = 'Get your Personal Loan Now !';
      break;
    // medicalExp
    case '49cf6f3c-6030-4869-b155-10ea3102b892':
      backGrndImg = medExp;
      backGrndImg2x = medExp2x;
      checkImg = checkWhite;
      textColor = 'white';
      leftHeading = 'Medical Expense Personal Loan';
      formHeading = 'Get Personal Loan for your Medical Expense Now !';
      break;
    // homeRenovation
    case 'ebce3582-b118-4545-98dd-1b8c1a19b6b2':
      backGrndImg = homeReno;
      backGrndImg2x = homeReno2x;
      checkImg = checkWhite;
      textColor = 'white';
      leftHeading = 'Home Renovation Personal Loan';
      formHeading = 'Get Personal Loan for your Home Renovation Now !';
      break;
    // wedding
    case '8a8991fb-c413-4cb0-9fd7-dd9a6e731ecc':
      backGrndImg = wedding;
      backGrndImg2x = wedding2x;
      checkImg = checkWhite;
      textColor = 'white';
      leftHeading = 'Wedding Personal Loan';
      formHeading = 'Get Personal Loan for your Wedding Now !';
      break;
    // educationLoan
    case 'c04ff766-36de-4fb7-86d6-0257358de674':
      backGrndImg = edu;
      backGrndImg2x = edu2x;
      checkImg = checkWhite;
      textColor = 'white';
      leftHeading = 'Education Personal Loan';
      formHeading = 'Get Personal Loan for your Education Now !';
      break;
    // credit
    case '17c7f699-966c-4f30-bf81-9a7c655280bc':
      backGrndImg = cred;
      backGrndImg2x = cred2x;
      checkImg = checkWhite;
      textColor = 'white';
      leftHeading = 'Credit Card Balance Transfer';
      formHeading = 'Clear your Credit card Debt Now!';
      break;
    // balanceTransfer
    case '66744846-56c0-4131-9df3-6b079b301a56':
      backGrndImg = bt;
      backGrndImg2x = bt2x;
      checkImg = checkWhite;
      textColor = 'white';
      leftHeading = 'Balance Transfer (BT) Personal Loan';
      formHeading = 'PL/Bt at 10.49% NOW!';
      break;
    // pl
    case '37bbaf4a-905d-45f1-b7fe-cddb7617f758':
      backGrndImg = pl;
      backGrndImg2x = pl2x;
      checkImg = checkWhite;
      textColor = 'white';
      leftHeading = 'Personal Loans starting at 10.49%';
      formHeading = 'Get your Personal Loan Now !';
      break;
    // minDoc
    case 'e186bd48-e4e2-4667-b70a-49e9b18f9244':
      backGrndImg = minDoc;
      backGrndImg2x = minDoc2x;
      checkImg = checkBlack;
      textColor = 'black';
      leftHeading = 'Minimum Documentation';
      formHeading = 'Get your Personal Loan Now !';
      mainLogo = lnLogoBlack;
      mainLogo2x = lnLogoBlack2x;
      break;
    // minSal
    case 'c7a51442-4868-4f62-ba7c-0148554d9c61':
      backGrndImg = sl;
      backGrndImg2x = sl2x;
      checkImg = checkBlack;
      textColor = 'black';
      leftHeading = 'Minimum Salary 25k';
      formHeading = 'Get your Personal Loan Now !';
      mainLogo = lnLogoBlack;
      mainLogo2x = lnLogoBlack2x;
      break;
  }

  const validationSchema = Yup.object().shape({
    Name: Yup.string()
      .min(1, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Required'),
    lastName: Yup.string()
      .min(1, 'Too Short!')
      .max(50, 'Too Long!')
      .required('Required'),

    email: Yup.string()
      .required('Required')
      .max(50, 'Email address is Too Long!')
      .matches(
        /^([a-z 0-9\.-_]+)@([a-z 0-9-]+).([a-z]{2,8})(.[a-z]{2,8})?$/,
        'Please Enter Valid Email Id'
      ),
    panNo: Yup.string()
      .required('Required')
      .matches(/[A-Z]{5}[0-9]{4}[A-Z]{1}$/, 'Incorrect format'),
    mobile: Yup.string()
      .required('Required')
      .max(10)
      .matches(/([6-9]\d{9})/, 'Mobile should be 10 digit number'),
  });
  if (
    !consentFlow &&
    code !== '4833255c-93cd-4a06-8a4f-91add21a5dcd' &&
    code !== '49cf6f3c-6030-4869-b155-10ea3102b892' &&
    code !== 'ebce3582-b118-4545-98dd-1b8c1a19b6b2' &&
    code !== '8a8991fb-c413-4cb0-9fd7-dd9a6e731ecc' &&
    code !== 'c04ff766-36de-4fb7-86d6-0257358de674' &&
    code !== '17c7f699-966c-4f30-bf81-9a7c655280bc' &&
    code !== '66744846-56c0-4131-9df3-6b079b301a56' &&
    code !== '37bbaf4a-905d-45f1-b7fe-cddb7617f758' &&
    code !== 'e186bd48-e4e2-4667-b70a-49e9b18f9244' &&
    code !== 'c7a51442-4868-4f62-ba7c-0148554d9c61'
  )
    return (
      <div className="absolute inset-3/10">
        <CircularLoading />
      </div>
    );
  else
    return (
      <Formik
        initialValues={{
          isOtpVerified: '',
          Name: '',
          lastName: '',
          mobile: '',
          email: '',
          panNo: '',
          permission: '',
        }}
        validationSchema={validationSchema}
      >
        {({
          values,
          handleChange,
          errors,
          touched,
          handleBlur,
          setFieldValue,
          setFieldTouched,
        }) => {
          // save api
          const saveConsent = () => {
            setCallingApi(true);
            setType('loading');
            setText('Submitting data please wait...');
            setShow(true);
            setDontClose(true);
            if (submitApi) {
              submitApi({
                requestId: requestId,
                otp: otp,
              })
                .then((res) => {
                  setShow(false);
                  setCallingApi(false);
                  setIsSubmitted(true);
                })
                .catch((err) => {
                  setCallingApi(false);
                  setShow(false);
                });
            } else {
              let body = {
                name: {
                  firstName: values?.Name,
                  middleName: '',
                  lastName: values?.lastName,
                },
                email: values?.email,
                phone: values?.mobile,
                loanType: loanType,
                source: source,
                panNumber: values?.panNo,
                otp: otp,
                metadata: JSON.stringify({
                  loanType: loanType,
                  source: source,
                  code: code,
                }),
              };
              consentUserCampaign(body)
                .then((res) => {
                  setShow(false);
                  setIsSubmitted(true);
                  setCallingApi(false);
                })
                .catch((error) => {
                  setIsSubmitted(true);
                  setCallingApi(false);
                  setShow(false);
                });
            }
          };
          useEffect(() => {
            if (consentFlow && userDetails)
              setFieldValue('email', userDetails?.consumerDetails?.email, true);
            setFieldValue(
              'Name',
              userDetails?.consumerDetails?.firstName,
              true
            );
            setFieldValue(
              'lastName',
              userDetails?.consumerDetails?.lastName,
              true
            );
            setFieldValue(
              'panNo',
              userDetails?.consumerDetails?.panNumber,
              true
            );
            setFieldValue('mobile', userDetails?.consumerDetails?.phone, true);
          }, [userDetails]);

          const resendOtp = () => {
            getCampaignOtp(values?.mobile)
              .then((res) => {
                setIsResending(false);
                setTimeLeft(30);
                setShowOptComp(true);
              })
              .catch((err) => {
                setIsResending(false);
                setErrMsg(
                  err?.response?.data?.message ||
                    'Unable to send the otp! please try again'
                );
              });
          };

          // otp timing func
          const countDown = () => {
            if (timeLeft > 0) {
              setTimeLeft((timeLeft) => Append_0(timeLeft - 1, 2));
            }
          };
          useEffect(() => {
            let x = setInterval(() => countDown(), 1000);
            if (timeLeft === 0) clearInterval(x);
            return () => clearInterval(x);
          }, [timeLeft]);

          useEffect(() => {
            if (values?.mobile?.length === 10) {
              resendOtp();
            } else setShowOptComp(false);
          }, [values?.mobile?.length]);
          const inputLength = values?.mobile?.length;

          return (
            <Layout customTitle="Personal Loan | Fincity">
              <div
                autoComplete="off"
                className=" relative h-full w-full  font-roboto text-sm font-normal m-0 p-0 min-h-screen max-w-full "
              >
                {/* backgroundImage */}
                <div className="hidden md:block fixed w-full h-full z-0">
                  <img
                    src={backGrndImg}
                    className="w-full h-full "
                    alt="backgroundImage"
                    srcSet={backGrndImg2x}
                  />
                </div>
                <div className="flex flex-col justify-between pt-2 md:pt-4 h-full w-full max-w-full min-h-screen">
                  <div className="flex flex-row w-full h-full z-10 md:px-5 xl:px-10 mb-5 md:mb-10 md:space-x-3">
                    {/* leftSide */}

                    <div className="ml-9 flex-1 hidden md:block z-10  ">
                      {/* mainLogo */}
                      <div className="relative self-start">
                        <img
                          className="h-20 w-28 mb-7 hidden md:block"
                          src={mainLogo}
                          srcSet={mainLogo2x}
                          alt="mainLogo"
                        />
                      </div>
                      <h1
                        className={
                          (textColor === 'black'
                            ? 'text-black-250'
                            : 'text-white') +
                          '  font-khand text-2xl md:text-3xl xmd:text-4xl font-semibold  '
                        }
                        style={{
                          ...(windowWidth <= 767
                            ? { fontSize: '2vw' }
                            : windowWidth <= 1440
                            ? { fontSize: '4vw' }
                            : { fontSize: '4vw' }),
                        }}
                      >
                        {leftHeading}
                      </h1>
                      <div
                        className="flex md:flex-wrap xl:flex-no-wrap mr-2  "
                        style={{
                          marginTop: '10px',
                        }}
                      >
                        {code === '4833255c-93cd-4a06-8a4f-91add21a5dcd' && (
                          <div className=" ">
                            <img
                              className="object-fit w-auto "
                              src={leftHome}
                              alt="house"
                              style={{
                                height: windowWidth > 1400 ? '400px' : '350px',
                              }}
                            />
                          </div>
                        )}
                        <AdvBlock
                          isDefault={isDefault}
                          textColor={textColor}
                          checkImg={checkImg}
                        />
                      </div>
                    </div>

                    {/* flow If its a consentFlow i.e action==='CREDIT_REPORT_CONSENT' */}

                    <div
                      className="relative flex-shrink-0  z-10 h-full md:w-27/50  max-w-full mx-auto md:ml-auto  px-2"
                      style={{
                        ...(windowWidth > 767 ? { width: 'max-content' } : {}),
                      }}
                    >
                      {/* login/signUp */}

                      <div
                        className={
                          'relative h-full md:w-11/12  md:max-w-sm lg:max-w-lg xxl:max-w-xl bg-white mb-0 pt:1 md:pt-2 z-10 font-roboto font-normal md:rounded-4xl mx-auto  md:ml-auto min-h-70v border border-grey-200 md:border-none'
                        }
                        style={{
                          ...(windowWidth > 767 && windowWidth < 1024
                            ? {
                                maxWidth: '26rem',
                              }
                            : windowWidth > 1023
                            ? {
                                minWidth: '28rem',
                              }
                            : {}),
                        }}
                      >
                        <div
                          className=" mx-auto  mb-5 md:mb-4 block"
                          style={{ width: 'fit-content' }}
                        >
                          <div
                            className={(!isSubmitted ? '' : 'pt-5') + ' pb-5'}
                          >
                            {!isSubmitted && (
                              <div
                                className=" bg-white cursor-pointer mx-auto"
                                style={{
                                  width: 'fit-content',
                                }}
                              >
                                <img
                                  src={logo}
                                  className={
                                    (consentFlow ? '' : '') +
                                    ' mx-auto  py-2 w-35 text-center hidden md:block '
                                  }
                                  alt="Fincity"
                                />
                                <img
                                  src={lnLogoBlue}
                                  className={
                                    (consentFlow ? '' : '') +
                                    ' mx-auto  py-2 w-28 h-20 text-center block md:hidden'
                                  }
                                  alt="Fincity"
                                />
                              </div>
                            )}
                            <div
                              className={
                                !consentFlow
                                  ? ' w-4/5 mx-auto bg-white pb-6'
                                  : 'px-10'
                              }
                            >
                              {!isSubmitted ? (
                                <Fragment>
                                  {!consentFlow && (
                                    <h4
                                      className=" text-center font-khand md:text-2xl lg:text-4xl  text-black-500 pb-6 font-semibold "
                                      style={{
                                        ...(windowWidth <= 767
                                          ? { fontSize: '5.5vw' }
                                          : windowWidth > 1113
                                          ? { fontSize: '35px' }
                                          : ''),
                                      }}
                                    >
                                      {formHeading}
                                    </h4>
                                  )}
                                  <div className="grid_input_container mb-5">
                                    <CommonInput
                                      name="Name"
                                      id="Name"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values?.Name}
                                      stylesContainer={{
                                        height: '52px',
                                        maxWidth: '100%',
                                      }}
                                      legendName="First Name"
                                      error={touched.Name && errors.Name}
                                      errorMsg={errors.Name}
                                      touched={touched.Name}
                                      disabled={consentFlow}
                                    />
                                  </div>
                                  <div className="grid_input_container mb-5">
                                    <CommonInput
                                      name="lastName"
                                      id="lastName"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                      value={values?.lastName}
                                      stylesContainer={{
                                        height: '52px',
                                        maxWidth: '100%',
                                      }}
                                      error={
                                        touched.lastName && errors.lastName
                                      }
                                      errorMsg={errors.lastName}
                                      legendName="Last Name"
                                      touched={touched.lastName}
                                      disabled={consentFlow}
                                    />
                                  </div>
                                  <div className="mobile_field mb-5">
                                    <div
                                      className={
                                        (errors.mobile ? 'mb-5' : 'mb-1') +
                                        ' grid_input_container relative '
                                      }
                                    >
                                      <div
                                        style={{ marginTop: '17px' }}
                                        className="absolute text-grey-50 z-10 font-normal text-sm pt-px text-md ml-4"
                                      >
                                        +91
                                      </div>
                                      <div>
                                        <CommonInput
                                          name="mobile"
                                          id="mobile"
                                          maxLength={10}
                                          showLoading={
                                            values?.mobile?.length === 10 &&
                                            !showOptComp
                                          }
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value={values?.mobile}
                                          stylesContainer={{
                                            height: '52px',
                                            maxWidth: '100%',
                                          }}
                                          inputStyle={{
                                            paddingLeft: '45px',
                                            letterSpacing: '1px',
                                          }}
                                          onBlurStyle={{
                                            paddingLeft: '20px',
                                          }}
                                          legendStyle={{
                                            paddingLeft: errors.mobile
                                              ? '20px'
                                              : '20px',
                                          }}
                                          legendName="Mobile Number"
                                          error={
                                            touched.mobile && errors.mobile
                                          }
                                          className={`pt-24`}
                                          touched={touched.mobile}
                                          errorMsg={errors.mobile}
                                          onKeyPress={(e) => {
                                            validatePhoneNumber(e, inputLength);
                                          }}
                                          disabled={consentFlow}
                                        />
                                      </div>
                                    </div>
                                    {consentFlow && (
                                      <p
                                        className="font-sans text-xs font-medium ml-2"
                                        style={{
                                          color: 'rgba(5, 47, 95, 0.6)',
                                        }}
                                      >
                                        Please Use the Mobile Number Registered
                                        with your Credit Card/Loan account
                                      </p>
                                    )}
                                    {errMsg && (
                                      <p className="font-roboto font-normal text-base text-red-300 w-full break-words text-center">
                                        {errMsg}
                                      </p>
                                    )}
                                  </div>
                                  {showOptComp ? (
                                    <div className="grid_input_container mb-4">
                                      {/* <OtpComp campaign /> */}

                                      <p className="font-roboto font-normal  text-black-400 md:text-black-1011 my-3">
                                        Please enter the 4-digit PIN we just
                                        sent to{' '}
                                        {[values?.mobile].map(
                                          (s) =>
                                            s?.slice(0, 2) +
                                            s
                                              .slice(2, 8)
                                              .replace(/\d{5}$/, '*****') +
                                            s?.slice(8)
                                        )}
                                      </p>
                                      <div
                                        className="text-center mx-auto "
                                        style={{ width: 'fit-content' }}
                                      >
                                        <CommonOtpInput
                                          length={4}
                                          className="otpContainerCampaign"
                                          inputClassName="otpInputCampaign"
                                          isNumberInput
                                          autoFocus
                                          onChangeOTP={(otp) => {
                                            setOtp(otp);
                                            setFieldValue('otp', otp, true);
                                            setErrMsg('');
                                          }}
                                        />
                                      </div>

                                      <div
                                        className="text-orange-1100 text-sm md:text-base font-roboto font-medium ml-auto mt-5 cursor-pointer"
                                        style={{ width: 'max-content' }}
                                        onClick={() => {
                                          setIsResending(true);
                                          resendOtp();
                                          setErrMsg('');
                                        }}
                                      >
                                        <div className="inline-flex items-center w-full ">
                                          {isResending && <NewSpinner />}
                                          {timeLeft > 0 && (
                                            <p className="text-grey-2232 font-roboto font-normal text-sm md:text-base mr-auto ml-2 ">
                                              <span
                                                className={
                                                  (timeLeft < 20 &&
                                                  timeLeft >= 10
                                                    ? 'text-red-100'
                                                    : timeLeft < 10
                                                    ? 'text-red-bloorRed'
                                                    : 'text-orange-1100') +
                                                  ' font-roboto font-medium text-lg '
                                                }
                                              >
                                                {` 00:${timeLeft}`}
                                              </span>
                                            </p>
                                          )}
                                          <button
                                            className="block  submitButton"
                                            disabled={timeLeft > 0}
                                            style={{
                                              marginLeft: '10px',
                                              marginTop: '0px',
                                            }}
                                          >
                                            RE-SEND OTP
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  ) : null}
                                  <div className="email_field mb-5 ">
                                    <div className="grid_input_container mb-1">
                                      <div>
                                        <CommonInput
                                          name="email"
                                          id="email"
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          value={values.email}
                                          stylesContainer={{
                                            height: '52px',
                                            maxWidth: '100%',
                                          }}
                                          legendName="Email ID"
                                          error={touched.email && errors.email}
                                          touched={touched.email}
                                          disabled={consentFlow}
                                        />
                                      </div>
                                    </div>
                                    {consentFlow && (
                                      <p
                                        className="font-sans text-xs font-medium ml-2"
                                        style={{
                                          color: 'rgba(5, 47, 95, 0.6)',
                                        }}
                                      >
                                        which has been used for your bank
                                        records
                                      </p>
                                    )}
                                  </div>
                                  <div className="grid_input_container mb-6">
                                    <div>
                                      <CommonInput
                                        name="panNo"
                                        id="panNo"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.panNo}
                                        stylesContainer={{
                                          height: '52px',
                                          maxWidth: '100%',
                                        }}
                                        legendName="PAN Number"
                                        error={touched.panNo && errors.panNo}
                                        errorMsg={errors.panNo}
                                        touched={touched.panNo}
                                        disabled={consentFlow}
                                      />
                                    </div>
                                  </div>
                                  {/* consent */}
                                  <div className="relative h-full w-full inline-flex flex-row   mt-1 items-center ">
                                    <div
                                      className="absolute w-1/5 "
                                      style={{
                                        height: '100%',
                                        backgroundColor: '#FD80231C',
                                      }}
                                    ></div>
                                    <CommonCheckbox
                                      containerStyles={{
                                        position: 'absolute',
                                        ...(windowWidth > 400
                                          ? { left: '5%' }
                                          : windowWidth > 300
                                          ? { left: '1%' }
                                          : { left: '-2%' }),
                                      }}
                                      inputStyles={{
                                        width: '24px',
                                        height: '24px',
                                        marginTop: '-10px',
                                        marginLeft: '12px',
                                        ...(!values?.permission
                                          ? {
                                              border: '2px solid #FD8023',
                                              borderRadius: '4px',
                                            }
                                          : {
                                              borderRadius: '4px',
                                              borderWidth: '2px',
                                            }),
                                      }}
                                      checked={values?.permission || false}
                                      name="permission"
                                      value={values.permission}
                                      onChange={(e) => {
                                        setFieldValue(
                                          'permission',
                                          e.target.checked,
                                          true
                                        );
                                        setFieldTouched(
                                          'permission',
                                          true,
                                          false
                                        );
                                      }}
                                      error={
                                        errors?.permission &&
                                        touched?.permission
                                      }
                                      onBlur={handleBlur}
                                    />

                                    <div className=" w-4/5 h-full bg-navy-600 p-3 ml-auto">
                                      <p className="text-xs block mt-px text-grey-2232 font-roboto font-normal tracking-wide ">
                                        I hereby declare that I have read the{' '}
                                        <a
                                          className="underline text-sm text-orange-1100 tracking-wide"
                                          href="/consent"
                                          target="_blank"
                                        >
                                          consent.
                                        </a>{' '}
                                        and I appoint and allow FINCITY to
                                        access my credit
                                        {showMore ? (
                                          <span>
                                            {' '}
                                            information from Credit Information
                                            Companies in order to understand my
                                            credit worthiness and thereinafter
                                            provide personalised values which
                                            would help them generate the Credit
                                            Information Report, Credit Score and
                                            Credit Analysis. I/We hereby
                                            authorize FINCITY & its affiliates
                                            including banking partners to call
                                            or SMS and/or WhatsApp with
                                            reference to my application or in
                                            relation to any of FINCITY products,
                                            notwithstanding anything to the
                                            contrary that may be contained
                                            anywhere, including any registration
                                            for DNC/ NDNC.
                                            {
                                              <span
                                                className="text-green-1000 text-xs font-roboto font-semibold cursor-pointer"
                                                onClick={() =>
                                                  setShowMore(false)
                                                }
                                              >
                                                {' '}
                                                less
                                              </span>
                                            }
                                          </span>
                                        ) : (
                                          <>
                                            <span>...</span>
                                            <span
                                              className="text-green-1000 text-xs font-roboto font-semibold cursor-pointer"
                                              onClick={() => setShowMore(true)}
                                            >
                                              {' '}
                                              more
                                            </span>
                                          </>
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                  <button
                                    type="submit"
                                    className="submitButton font-roboto text-white text-base w-full"
                                    disabled={
                                      callingApi ||
                                      !values?.permission ||
                                      errors.lastName ||
                                      errors.Name ||
                                      errors.mobile ||
                                      errors.email ||
                                      errors.panNo ||
                                      errMsg ||
                                      otp.length !== 4 ||
                                      values.lastName == '' ||
                                      values.Name == '' ||
                                      values.mobile == ''
                                    }
                                    onClick={saveConsent}
                                  >
                                    {consentFlow
                                      ? 'Get my Credit Report'
                                      : 'Get Approval'}
                                  </button>
                                </Fragment>
                              ) : (
                                <ThankYouPage
                                  campaign
                                  consentFlow={consentFlow}
                                  managerDetailsConsent={managerDetailsConsent}
                                />
                              )}
                            </div>
                          </div>
                          <PopUp
                            type={type}
                            text={text}
                            setShow={setShow}
                            show={show}
                            dontClose={dontClose}
                            autoClose={type === 'success'}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-center w-full px-2 py-2 font-khand text-3xl text-black-500 pb-6 font-semibold md:hidden">
                    {leftHeading}
                  </div>
                  <div className="block md:hidden relative h-79 w-full rounded-xl mb-4 px-2 overflow-hidden box-border">
                    <div className="relative h-full w-full">
                      <div
                        className="absolute  z-20 h-full w-full rounded-xl max-w-full "
                        style={{
                          background: '#000000 0% 0% no-repeat padding-box',
                          opacity: '0.52',
                        }}
                      ></div>
                      <img
                        src={backGrndImg}
                        className="static w-full h-full rounded-xl z-10 "
                        alt="backgroundImage"
                        srcSet={backGrndImg2x}
                      />
                    </div>

                    <AdvBlock
                      isDefault={isDefault}
                      textColor={textColor}
                      checkImg={checkImg}
                      absolute
                      windowWidth={windowWidth}
                    />
                  </div>

                  {/* footer */}
                  <div
                    className=""
                    style={{
                      background: `#363636 0% 0% no-repeat padding-box`,
                      opacity: windowWidth < 768 ? '0.9' : '0.66',
                      backdropFilter: 'blur(22px)',
                    }}
                  >
                    <div className=" grid grid-cols-2 xs:grid-cols-2 md:grid-cols-3 xmd:grid-cols-4  xl:grid-cols-6 place-content-center justify-center  md:place-items-end gap-2  xxl:gap-2 md:justify-around w-full py-5  px-5 md:px-2  text-sm  md:text-left md:w-11/12 mx-auto z-10">
                      {footerItems.map(({ logo, title, subTitle }) => (
                        <div
                          key={logo.src + logo.alt}
                          className={`flex flex-col xmd:flex-row place-items-center justify-center place-self-center xmd:place-self-start my-1 md:my-0  ${
                            title ? ' md:mx-2' : ''
                          }`}
                          style={{
                            witdh: 'fit-content',
                          }}
                        >
                          <img
                            className="w-14 xxl:w-15 h-14 xxl:h-15 mr-2"
                            src={logo.src}
                            alt={logo.alt}
                          />
                          <div className="flex flex-col mx-auto">
                            {title && (
                              <div className="font-roboto font-medium text-sm  text-center xmd:text-left text-orange-1100">
                                {title}
                              </div>
                            )}
                            {subTitle && (
                              <div className="text-base  text-center xmd:text-left text-white">
                                {subTitle}
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                    </div>
                    {/* // ssl */}
                    <div
                      className={`relative w-full md:my-0 h-12 bg-black-0 px-2`}
                    >
                      <div
                        className="mx-auto flex flex-row justify-center h-full   "
                        style={{
                          width: 'fit-content',
                        }}
                      >
                        <div
                          className="inline-flex items-center  mr-2"
                          style={{
                            width: 'fit-content',
                          }}
                        >
                          <img
                            className="w-6 h-6 mr-2"
                            src={safe}
                            alt={'iso'}
                          />
                          <div className="font-roboto text-xs  text-left text-white">
                            Safe & Secure
                          </div>
                        </div>
                        <div
                          className="bg-teal mt-1 ml-2 "
                          style={{
                            width: '1px',
                            height: '80%',
                          }}
                        ></div>
                        <div className="inline-flex items-center ml-1 sm:ml-3">
                          <img
                            className="w-6 h-6 mr-2"
                            src={iso}
                            alt={'safe'}
                          />
                          <div className="font-roboto text-xs  text-left text-white ">
                            ISO 27001 Certified
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* our actual current flow */}
            </Layout>
          );
        }}
      </Formik>
    );
};
export default campaign;
